import { Image } from '@/components/Image';

interface IProps {
  moveToTop: () => void;
}

export const PhotocardFloatingBtn = ({ moveToTop }: IProps) => {
  return (
    <button
      className="fixed right-4 bottom-[120px] h-[60px] w-[60px] flex justify-center items-center rounded-[16px] [box-shadow:0px_10px_20px_0px_rgba(0,0,0,0.25)] cursor-pointer"
      onClick={moveToTop}
    >
      <Image src="/icons/arrow-top.svg" alt="arrow-top" width={24} />
    </button>
  );
};
